var app = angular.module("storefrontApp");
app.controller("frequentlyBoughtTogetherContoller", [
    "$scope",
    "elasticService",
    "catalogService",
    "$rootScope",
    "loaderService",
    "cartService",
    "$window",
    function (
        $scope,
        elasticService,
        catalogService,
        $rootscope,
        loaderService,
        cartService,
        $window
    ) {
        $scope.productsPool = [];
        $scope.productSummary = [];
        $scope.totallistPrice = 0;
        $scope.totalsalePrice = 0;
        $scope.totalclubPrice = 0;


        $scope.generateGuid = function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        };

      
       // getItemPacks();
        $scope.getItemPacks = function(prdId,catalog) {
            loaderService.show();
            catalogService
                .getFrequentlyBoughtProducts(prdId,catalog)
                .then(function (response) {
                    var data = response.data;
                    $scope.productsPool = data.mappedAssociatedItems.split(",");
                    $scope.seriesId = $scope.generateGuid();
                    $scope.discountRate = response.data.discountRate || 1;
                    $scope.discountPercentage = $scope.discountRate ? 
                        Math.round((1 / $scope.discountRate) * 100) : 0;
                    elasticService
                        .getElasticData(
                            elasticService.buildProductInfoRequest(
                                $scope.productsPool,
                                undefined,
                                undefined,
                                true
                            )
                        )
                        .then(function (responseData) {
                            if (
                                responseData &&
                                responseData.data &&
                                responseData.data.hits &&
                                responseData.data.hits.hits.length > 0
                            ) {
                                $scope.productInfo =
                                    responseData.data.hits.hits;

                                for (
                                    var i = 0;
                                    i < $scope.productInfo.length;
                                    i++
                                ) {
                                    var product = $scope.productInfo[i]._source;
                                    var salePrice = !isNaN(product.salePrice) ? parseFloat(product.salePrice) : 0; // Convert to number or set to 0 if NaN
                                    var discountRate =  parseFloat($scope.discountRate); // Convert to number or set to 1 if NaN (to avoid division by zero)
                                    var calculatedSalePrice = salePrice !== 0 ? salePrice - (salePrice / discountRate) : product.listPrice - (product.listPrice / discountRate);
                                    var clubPrice = !isNaN(product.clubPrice) ? parseFloat(product.clubPrice) : salePrice;
                                    var calculatedClubprice = clubPrice !== 0 ? clubPrice - (clubPrice / discountRate) : calculatedSalePrice;
                                    // Create a summary object with required fields
                                    if(calculatedClubprice > calculatedSalePrice){
                                        calculatedClubprice = calculatedSalePrice;
                                    }
                                    $scope.totallistPrice += salePrice !== 0 ? salePrice : product.listPrice;
                                    $scope.totalsalePrice += calculatedSalePrice;
                                    $scope.totalclubPrice += calculatedClubprice;
                                    var productDetails = {
                                        name: product.name,
                                        listPrice: salePrice !== 0 ? salePrice : product.listPrice,
                                        variants: product.variants.length,
                                        definitionName: product.definitionName,
                                        catalog: product.catalog,
                                        itemId: product.itemId,
                                        rating: product.rating,
                                        runTime: product.runTime,
                                        selected: true,
                                    };

                                    // Push this object into the summary array
                                    $scope.productSummary.push(productDetails);
                                }
                               
                                loaderService.hide();
                            }
                        });
                });
                
        }

        $scope.addMultipleItemToCart = function () {
            var addItemPromises = $scope.productSummary.map(function (item) {
                return $scope.addItemToCart(item);
            });
            Promise.all(addItemPromises).then(function () {
                loaderService.hide();
                $window.location.href = "/cart";
            })
        };
        $scope.addItemToCart = function (item) {
            loaderService.show();
                if (item) {
                   return cartService
                        .addMultipleProductsAsLineItems(item.itemId, 1,$scope.seriesId)
                        .then(function (response) {
                            if (
                                response &&
                                response.data &&
                                response.data.itemAdded
                            ) {
                                //$scope.resetFilters();
                                $rootscope.$broadcast("CustomerCartChanged");

                            }
                           
                           return response;
                        })
                        .catch(function (error) {
                            loaderService.hide();
                            return Promise.reject(error); 
                        });;
                } else {
                    loaderService.hide();
                    return Promise.resolve();
                }
            
        };

        $scope.checkedItems = function () {
            $scope.listPrice1 = 0;
            $scope.salePrice1 = 0;
            var checkedItemsPrice = $scope.productSummary.filter(function (
                prdcheck
            ) {
                return prdcheck.selected === true;
            });
            checkedItemsPrice.forEach(function (itemprice) {
                $scope.listPrice1 += parseFloat(itemprice.listPrice);
                if (itemprice.salePrice != undefined)
                    $scope.salePrice1 += parseFloat(itemprice.salePrice);
            });
        };
    },
]);
